import {InjectionToken} from '@angular/core';
import {ApiConfig} from '../app-config';

export let APP_CONFIG = new InjectionToken<ApiConfig>('app.config');
